export const colors = {
  accent: {
    main: '#FFC14A'
  },
  newBlack: '#222229',
  secondary: {
    main: '#08080C',
    secondary50: '#050508',
    secondary40: '#060609',
    secondary30: '#07070A',
    secondary20: '#07070A',
    secondary10: '#08080B',
    secondaryTint10: '#161621',
    secondaryTint20: '#242436',
    secondaryTint30: '#32324B'
  },
  primary: {
    main: '#FAFAFA',
    primary50: '#A1A1A1',
    primary40: '#B3B3B3',
    primary30: '#C4C4C4',
    primary20: '#D6D6D6',
    primary10: '#E8E8E8',
    primaryTint30: '#FDFDFD',
    primaryTint10: '#FBFBFB',
    primaryTint50: '#FFFFFF'
  },
  red: {
    main: '#DE350B',
    red50: '#C12300',
    red40: '#D72700',
    red30: '#EC2B00',
    red20: '#FF3103',
    red10: '#FF4318'
  },
  green: {
    main: '#36CE2A',
    green50: '#22851B',
    green40: '#26941E',
    green30: '#2AA321',
    green20: '#2EB224',
    green10: '#32C127'
  }
};
